















































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import user from '@/store/modules/user';
import payment from '@/store/modules/payment';
import to from 'await-to-js';
import redirectToLocation, { getFullUrl } from '@/commons/redirectManager';
import {
    Address as AddressModel,
    Address,
    CartItem,
    Country,
    PaymentInformationRequest,
    PaymentMethod,
    QuoteAddress,
    Totals,
    TotalSegment,
    UserRegistrationRequest,
    Telesales, ShippingInfoData,
} from '@/store/models';
import AddressList from '@/components/Address/List.vue';
import AddressForm from '@/components/Address/Form.vue';
import ShippingInfo from '@/components/Address/ShippingInfo.vue';
import ShippingTimesMessage from '@/components/Shipping/Times.vue';
import Coupon from '@/components/Cart/Coupon.vue';
import { clone, cloneDeep, get as dataGetter, merge } from 'lodash';
import addressNormalizer, {
    addExtensionAttributes,
    normalizeQuoteAddress,
    quoteAddressToCustomerAddress,
} from '@/commons/addressNormalizer';
import RequestInvoice from '@/components/Checkout/RequestInvoice.vue';
import PaypalButton from '@/components/Checkout/PaymentStep/PaypalButton.vue';
import { findRegions } from '@/commons/regionFinder';
import store from '@/store';
import { err } from '@/commons/toast';
import Agreement from '@/components/Cms/Agreement.vue';
import PaymentMethodSelection from '@/components/Cart/PaymentMethodSelection.vue';
import CartTotals from '@/components/Cart/Totals.vue';
import {
    createMagentoOrder,
    getTotals,
    redirectToScalapay,
    saveLog,
    updateShippingTelephone,
    userSaveData,
    validateBeforePlace,
} from '@/store/api';
import { bus } from '@/events/bus';
import paidEvent from '@/events/paid';
import gtmhelpers from '@/commons/gtmhelpers';
import Modal from '@/components/UI/Modal.vue';
import ui from '@/store/modules/ui';
import handleError from '@/commons/errorHandler';
import { Validator } from 'vee-validate';
import addressValidator from '@/commons/addressValidator';
import scrollToInput from '@/commons/scrollto';
import { i18n } from '@/i18n';
import { addLocalStorageOrder } from '@/commons/localStorage';
import device from '@/store/modules/device';
import Tax from '@/components/Sidebar/Tax.vue';
import { hideHubSpotPopup, showHubSpotPopup } from '@/commons/hubspot';
import { initState } from '@/store/stateinit';
import handleMessage from '@/commons/messageManager';
import {decode as decodeShipment} from '@/commons/shipmentMethodHelpers';
import stripe from '@/store/modules/stripe';

const paymentAliases: any = {};
paymentAliases[store.state.options.payment.paypal.code] = 'paypal';
paymentAliases[store.state.options.payment.paypal_paylater.code] = 'paypal';
paymentAliases[store.state.options.payment.hipay.code] = 'hipay';
paymentAliases[store.state.options.payment.hipay_paypal.code] = 'hipay_paypal';
paymentAliases[store.state.options.payment.hipay_oney.code] = 'hipay_paypal';
paymentAliases[store.state.options.payment.hipay_paybylink.code] = 'hipay_paybylink';
paymentAliases[store.state.options.payment.hipay_moto.code] = 'hipay_moto';

Component.registerHooks(['mounted']);

@Component({
    components: {
        AddressList,
        RequestInvoice,
        AddressForm,
        ShippingInfo,
        ShippingTimesMessage,
        Agreement,
        PaymentMethodSelection,
        CartTotals,
        Modal,
        Tax,
        Coupon,
        PaypalButton,
    },
    provide() {
        return {
            $validator: this.$validator,
        };
    },
})
export default class InvoiceStep extends Vue {
    public guestEmail: string | null = null;
    public telesalesAgentCode: Telesales = initState('telesales');
    private changeAddressFlag: boolean = false;
    private loading: boolean = false;
    private methodsInitPromisesString: Array<Promise<string>> = [];
    private methodsInitPromises: Array<Promise<boolean>> = [];
    private additionalData = {
        email: '',
        emailexistsmess: '',
    };
    private addressSelected = false;
    private paymentData: any = {
        hipay: {
            isWidgetLoading: false,
        },
    };
    private isGuestEmailAssigning = false;

    get guestEmailAssigning() {
        return this.isGuestEmailAssigning;
    }

    get isVipQuote(): boolean {
        return cart.cart.extension_attributes && cart.cart.extension_attributes.is_vip_cart;
    }

    get isVirtual(): boolean {
        return cart.isVirtual;
    }

    get sameAsShipping(): boolean {
        return !this.isVirtual && checkout.billingSameAsShipping;
    }

    set sameAsShipping(val: boolean) {
        checkout.setBillingSameAsShipping(val);
    }

    get address(): QuoteAddress {
        return checkout.billingAddress;
    }

    get hasDefaultBillingAddress(): boolean {
        let defaultBilling = false;
        user.customer.addresses.forEach((address) => {
            if (address.default_billing) {
                defaultBilling = true;
            }
        });

        return defaultBilling;
    }

    get hasAddresses(): boolean {
        return user.customer.addresses.length > 0;
    }

    get checkAddressList(): boolean {
        if (this.isLogged) {
            return false;
        }
        return user.customer.addresses.length > 1;
    }

    get shippingAddress(): QuoteAddress {
        return checkout.shippingAddress;
    }

    get billingAddress(): QuoteAddress {
        return checkout.billingAddress;
    }

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get isLoading(): boolean {
        return cart.loadingFlags.totals || this.loading;
    }

    get totalsIsLoading(): Totals {
        return cart.loadingFlags.totals;
    }

    get selectedMethod(): string {
        return checkout.selectedPaymentMethod ? checkout.selectedPaymentMethod.code : '';
    }

    get selectedPaymentMethod(): PaymentMethod {
        return checkout.selectedPaymentMethod;
    }

    get isChangeAddress() {
        return this.changeAddressFlag;
    }

    get isMobile() {
        return device.isMobile;
    }

    get selectedShippingMethod() {
        return checkout.selectedShippingMethod;
    }

    get checkoutEmail(): string {
        return checkout.email;
    }

    set checkoutEmail(email: string) {
        checkout.setEmail(email);
    }

    get countryRegions() {
        return findRegions(this.address.country_id);
    }

    get countries(): Country[] {
        return store.state.countryData.countries;
    }

    get items(): CartItem[] {
        // get method si traduce in una computed
        return cart.cart.items;
    }

    get totals(): Totals {
        return cart.totals;
    }

    get isConfirmStep(): boolean {
        return checkout.confirmStep;
    }

    get requestInvoice(): boolean {
        return checkout.requestInvoice.requested;
    }

    get hasNoVatFlag(): boolean {
        if (!store.state.options.requestinvoice.novat_flag) {
            return false;
        }
        if (store.state.options.requestinvoice.novat_countries === '') {
            return true;
        }
        return store.state.options.requestinvoice.novat_countries
            .split(',')
            .includes(checkout.billingAddress.country_id);
    }

    get novatRequested(): number {
        return checkout.requestInvoice.novatrequested;
    }

    get getPrivacyText(): string {
        return store.state.options.register_agreements.privacy.text;
    }

    get getPrivacyLabel(): string {
        return store.state.options.register_agreements.privacy.label;
    }

    get getPrivacyLink(): string {
        return store.state.options.register_agreements.privacy.link;
    }

    get getSalesText(): string {
        return store.state.options.register_agreements.sales.text;
    }

    get getSalesLabel(): string {
        return store.state.options.register_agreements.sales.label;
    }

    get getSalesLabelAfter(): string {
        return store.state.options.register_agreements.sales.labelAfter;
    }

    get getSalesLink(): string {
        return store.state.options.register_agreements.sales.link;
    }

    get agreements() {
        return checkout.agreements;
    }

    get agreementsAccepted() {
        return checkout.agreementsAccepted;
    }

    get isCheckReview() {
        return checkout.checkReview;
    }

    get grandTotal(): number {
        const grandTotal = cart.totals.total_segments.find((total) => total.code === 'grand_total');
        return grandTotal ? grandTotal.value : 0;
    }

    get agentCode(): string {
        return this.telesalesAgentCode.agent_code;
    }

    get educationSalesConditions() {
        return checkout.educationSalesConditions;
    }

    get showEducationSalesCondition() {
        return checkout.showEducationSalesCondition;
    }

    get isOrderPlaced() {
        return checkout.orderPlaced;
    }

    get isPlacingOrder() {
        return checkout.placingOrder;
    }

    public isItemFree(item: CartItem) {
        return item.extension_attributes.extfree_gift_message !== '';
    }

    public showOldPrice(item: CartItem) {
        return (
            item.extension_attributes.extoriginal_price >
            (item.extension_attributes.extcustom_price || item.extension_attributes.extfinal_price)
        );
    }

    public getDiscountPercentage(item: CartItem) {
        const finalPrice = item.extension_attributes.extcustom_price || item.extension_attributes.extfinal_price;

        return Math.round(
            ((item.extension_attributes.extoriginal_price - finalPrice) / item.extension_attributes.extoriginal_price) *
                100,
        );
    }

    @Watch('isConfirmStep')
    public updatePaypalPosition() {
        if (this.isConfirmStep) {
            const paypalButton = this.$refs.paypalButton as PaypalButton;
            const proceedContainer = this.$refs.proceedContainer as HTMLDivElement;
            const proceedContainerMobile = this.$refs.proceedContainerMobile as HTMLDivElement;

            if (paypalButton) {
                if (this.isMobile) {
                    if (paypalButton.$el.closest('.checkout-sidebar')) {
                        proceedContainerMobile.append(paypalButton.$el);
                    }
                } else if (!paypalButton.$el.closest('.checkout-sidebar')) {
                    proceedContainer.prepend(paypalButton.$el);
                }
            }
        }
    }

    private hasNotes(method: PaymentMethod): boolean {
        return method.title.includes('|') || false;
    }

    private isSameAsShipping() {
        return checkout.billingSameAsShipping;
    }

    private getselectedMethodTitle(): string {
        const method = checkout.selectedPaymentMethod;

        if (method) {
            if (this.hasNotes(method)) {
                const title = method.title.split('|');
                return title[0];
            }

            return method.title;
        }

        return '';
    }

    private closeHipayModal() {
        ui.closeModal('hipay');
        this.loading = false;
        checkout.flagPlacingOrder(false);
        redirectToLocation('/checkout/cart');
    }

    private getselectedMethodDescription(): string {
        const method = checkout.selectedPaymentMethod;

        if (method) {
            const paymentDescription = checkout.paymentDescriptions.find((m) => {
                return m.code === method.code;
            });

            return paymentDescription ? paymentDescription.description : '';
        }

        return '';
    }

    private isCouponVisibleOnInvoiceStep() {
        return store.state.options.coupon.payment_step === 1;
    }

    private async addressFormSubmittedHandler(addressData: QuoteAddress) {
        const valid = await this.$validator.validateAll();

        if (valid) {
            this.saveNewAddress(addressData);
        }
    }

    private mounted() {
        checkout.setBillingSameAsShipping(true);
        if (document.getElementById('sales-agreement-education')) {
            document.getElementById('sales-agreement-education')!.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.openModal('sales-agreement-modal');
            });
        }
        window.addEventListener('resize', this.updatePaypalPosition);

        if (!checkout.selectedAddressId.shipping && !this.isVirtual) {
            handleMessage('error', this.$t('Choose a shipping address').toString());
            this.goToShipping();
            return;
        }

        // Remove BillingSameAsShipping if virtual order
        if (this.isVirtual) {
            checkout.setBillingSameAsShipping(false);
            this.setAddressOnNotSameAsShipping();
        }

        // Zero Checkout Payment
        if (this.getGrandTotal(this.totals.total_segments) <= 0) {
            checkout.setSelectedPayment('free');
            checkout.setPayment('free');
        }

        if (!this.address.firstname || this.isSameAsShipping()) {
            if (checkout.selectedAddressId.shipping) {
                let selectedAddress = this.getAddressFromCustomer(checkout.selectedAddressId.shipping);

                if (selectedAddress) {
                    selectedAddress = addressNormalizer(selectedAddress);
                    delete selectedAddress.id;
                    this.addressSelectedHandler(selectedAddress);
                }
            }
        }

        const hipayConfig = store.state.options.payment.hipay;
        if (!hipayConfig.use_hostedfields) {
            if (hipayConfig.payment_action === 'order') {
                const hipayRegistrationReq = { methodCode: 'hipay', params: hipayConfig };
                this.methodsInitPromises.push(payment.registerMethod(hipayRegistrationReq));
            }
        }

        let hipayImmediatePlace = store.state.options.payment.hipay_oney.payment_action === 'order';

        if (hipayImmediatePlace) {
            const hipayRegistrationReq = { methodCode: 'hipay_oney', params: store.state.options.payment.hipay_oney };
            this.methodsInitPromises.push(payment.registerMethod(hipayRegistrationReq));
        }

        hipayImmediatePlace = store.state.options.payment.hipay_moto.payment_action === 'order';

        if (hipayImmediatePlace) {
            const hipayRegistrationReq = {
                methodCode: 'hipay_moto',
                params: store.state.options.payment.hipay_moto,
            };
            this.methodsInitPromises.push(payment.registerMethod(hipayRegistrationReq));
        }

        if (store.state.options.payment.hipay_applepay.active) {
            const hipayApplePayRegistrationReq = {
                methodCode: 'hipay_applepay',
                params: store.state.options.payment.hipay_applepay,
            };
            this.methodsInitPromises.push(payment.registerMethod(hipayApplePayRegistrationReq));
        }

        if (store.state.options.payment.hipay_bancontact.active) {
            this.methodsInitPromises.push(
                payment.registerMethod({
                    methodCode: 'hipay_bancontact',
                    params: store.state.options.payment.hipay_bancontact,
                }),
            );
        }
        if (store.state.options.payment.hipay_sofort.active) {
            this.methodsInitPromises.push(
                payment.registerMethod({
                    methodCode: 'hipay_sofort',
                    params: store.state.options.payment.hipay_sofort,
                }),
            );
        }

        const klarnaConfigs = dataGetter(store.state.options.payment, 'klarna.payment');
        if (klarnaConfigs !== undefined) {
            for (const paymentCode of Object.keys(klarnaConfigs)) {
                const paymentConfigs = klarnaConfigs[paymentCode];
                if (paymentConfigs.enabled) {
                    this.methodsInitPromises.push(
                        payment.registerMethod({
                            methodCode: paymentCode,
                            params: paymentConfigs,
                        }),
                    );
                }
            }
        }

        addLocalStorageOrder();
        gtmhelpers.trackPageview(this.$router.currentRoute.fullPath);

        device.updateMobileDetection();

        // Show hubspot popup
        showHubSpotPopup();
    }

    @Watch('sameAsShipping')
    private onFlagChange(val: any) {
        if (val) {
            checkout.setBillingSameAsShipping(true);
            const shippingAddressClone = clone(addressNormalizer(this.shippingAddress)) as QuoteAddress;
            delete shippingAddressClone.id;
            merge(this.address, shippingAddressClone);
        } else {
            checkout.setBillingSameAsShipping(false);
            this.setAddressOnNotSameAsShipping();
        }
    }

    @Watch('agreements.privacy')
    private onPrivacyChange() {
        this.validatePrivacy();
    }

    @Watch('agreements.sales')
    private onSalesChange() {
        this.validateSales();
    }

    @Watch('agreements.education')
    private onEducationChange() {
        this.validateEducationSalesConditions();
    }

    @Watch('address.country_id')
    private onCountryIdChange(val: any, oldVal: any) {
        if (val && oldVal && val !== oldVal && this.isChangeAddress) {
            this.address.region = '';
            this.address.region_id = 0;
        }
    }

    private changeAddress() {
        this.changeAddressFlag = !this.changeAddressFlag;
        this.setAddressOnBack();
    }

    private setAddressOnBack() {
        if (checkout.selectedAddressId.billing) {
            let selectedAddress = this.getAddressFromCustomer(checkout.selectedAddressId.billing);

            if (selectedAddress) {
                selectedAddress = addressNormalizer(selectedAddress);
                delete selectedAddress.id;
                this.addressSelectedHandler(selectedAddress);
            }
        }
    }

    private setAddressOnNotSameAsShipping() {
        if (checkout.selectedAddressId.shipping) {
            let selectedAddress = this.getAddressFromCustomer(checkout.selectedAddressId.shipping);

            if (selectedAddress) {
                selectedAddress = addressNormalizer(selectedAddress);
                delete selectedAddress.id;
                this.addressSelectedHandler(selectedAddress);
            }
        }
    }

    private getAddressFromCustomer(id: number): Address | undefined {
        return user.customer.addresses.find((a) => a.id === id);
    }

    private addressSelectedHandler(address: any) {
        this.addressSelected = true;

        if (cart.isVirtual) {
            const differentCountry = address.country_id !== this.address.country_id;
            this.address.street = [''];
            merge(this.address, address);
            const addressClone = clone(this.address);
            const shippingInfoData: ShippingInfoData = {
                address: normalizeQuoteAddress(addressClone) as QuoteAddress,
                shippingmethod: decodeShipment(checkout.selectedShipment),
                removeOptions: differentCountry,
            };

            checkout
                .setShippingInfo(shippingInfoData)
                .then(() => {
                    checkout.checkSingleShippingMethod();
                })
                .catch(() => {
                    redirectToLocation('/checkout/cart');
                });

            normalizeQuoteAddress(addressClone);
        }

        checkout.setBillingAddress(address);
        cart.flagLoading({ key: 'totals', value: true });
        checkout.getPaymentMethods(address, checkout.shippingAddress).finally(() => {
            cart.flagLoading({ key: 'totals', value: false });
        });
    }

    private checkOneyTelephone(phone: any): boolean {
        const regex: RegExp = /^((?:0039)?|(?:\+39)?)3[0-9]{8,9}$/;
        return regex.test(phone);
    }

    private assertSelectedPayment(type: string, paymentMethod: string) {
        // eslint-disable-next-line no-prototype-builtins
        return (paymentAliases.hasOwnProperty(paymentMethod) ? paymentAliases[paymentMethod] : paymentMethod) === type;
    }

    private isButtonPayment(paymentMethod: string) {
        return (
            this.assertSelectedPayment('paypal', paymentMethod) ||
            this.assertSelectedPayment('hipay_applepay', paymentMethod)
        );
    }

    private goToCart() {
        this.$router.push({ path: '/' });
    }

    private goToShipping() {
        this.$router.push({ path: '/checkout/shipping' });
    }

    private goToInvoice() {
        checkout.setConfirmStep(false);
        checkout.setCheckReview(true);
        checkout.flagStep({ flag: false, type: 'u', stepName: 'confirm' });
        checkout.flagStep({ flag: false, type: 'a', stepName: 'confirm' });
        checkout.flagStep({ flag: true, type: 'a', stepName: 'invoice' });
        window.scrollTo(0, 0);
    }

    private checkAgreements() {
        if (!checkout.agreementsAccepted) {
            handleMessage('error', i18n.t('Accept all agreements to proceed').toString());
        }
    }

    private async saveNewAddress(addressData: any) {
        const changeAddressformRef = this.$refs.changeaddressform as any;
        const addressformRef = this.$refs.addressform as any;

        if (addressformRef || changeAddressformRef) {
            let valid = false;

            if (addressformRef) {
                valid = await addressformRef.isValid();
            } else {
                valid = await changeAddressformRef.isValid();
            }

            if (!valid) {
                return;
            }
        }

        this.loading = true;
        const oldAddressIds = user.customer.addresses.map((a) => a.id);
        const normalized = quoteAddressToCustomerAddress(addressData) as AddressModel;
        delete normalized.id;
        user.resetAddressErrors();

        const userObj = cloneDeep(user.customer) as unknown as UserRegistrationRequest;

        let selectedAddress = this.getAddressFromCustomer(checkout.selectedAddressId.billing);

        if (selectedAddress) {
            selectedAddress = addressNormalizer(selectedAddress);
        }

        if (!this.hasDefaultBillingAddress) {
            normalized.default_billing = true;
        }

        userObj.addresses.push(normalized);

        if (this.isLogged) {
            userSaveData(userObj)
                .then((res) => {
                    for (const a of res.addresses) {
                        if (!oldAddressIds.includes(a.id)) {
                            user.customer.addresses.push(addExtensionAttributes(a));
                            checkout.billingAddress.customer_address_id = a.id;
                            checkout.setSelectedAddressId({ type: 'billing', id: a.id });
                            break;
                        }
                    }
                    // Set default_billing in user to maintain data in app
                    user.customer.default_billing = res.default_billing;
                })
                .catch((e) => {
                    this.loading = false;
                    handleError(e);
                });
        } else {
            user.customer.addresses.push(addressData);
            checkout.selectedAddressId.billing = addressData.id;
        }

        this.addressSelected = true;
        this.changeAddressFlag = false;
        addressData.id = checkout.billingAddress.id;
        addressData.customer_address_id = checkout.selectedAddressId.billing;
        checkout.setBillingAddress(addressData);

        checkout.getPaymentMethods(addressData, checkout.shippingAddress).finally(() => {
            this.loading = false;
        });

        this.loading = false;
    }

    private async validate() {
        let valid = await this.$validator.validateAll();
        const invoiceFields = this.$refs.requestinvoice as RequestInvoice;
        let validator = new Validator();

        if (invoiceFields) {
            validator = invoiceFields.$validator;
            const invoiceFieldsValid = await validator.validateAll();

            if (!invoiceFieldsValid) {
                valid = false;
            }
        }

        const errorRendering = () => {
            this.$validator.errors.all().forEach((error) => {
                handleMessage('error', error);
            });

            validator.errors.all().forEach((error) => {
                handleMessage('error', error);
            });
        };

        return new Promise((resolve, reject) => {
            if (this.hasAddresses && !this.address.firstname && !this.sameAsShipping) {
                handleMessage('error', this.$t('Seleziona un indirizzo').toString());
                reject();
            }

            if (!this.selectedMethod && this.getGrandTotal(this.totals.total_segments) > 0) {
                handleMessage('error', this.$t('Select a payment method').toString());
                reject();
            }

            if (!this.checkAddress()) {
                reject();
            }

            if (!valid) {
                reject(errorRendering);
            }

            resolve(true);
        });
    }

    private async confirmOrPlace(paymentMethod: string) {
        if (this.isLogged && !this.addressSelected) {
            handleMessage('error', this.$t('Create new address to proceed').toString());
            return;
        }

        if (!this.isLogged && !this.isValidEmail(this.checkoutEmail)) {
            handleMessage('error', this.$t('Insert a valid email address to proceed').toString());

            return;
        }

        if (this.requestInvoice === null) {
            handleMessage('error', this.$t('Choose whether to have the invoice or not to proceed').toString());

            return;
        }

        if (this.hasNoVatFlag && (this.requestInvoice && this.novatRequested === 0)) {
            handleMessage('error', this.$t('Choose whether you have a VAT number or are a small business').toString());

            return;
        }

        if (this.isConfirmStep) {
            checkout.setCheckReview(true);
            const valid = await this.$validator.validateAll();

            if (!valid) {
                if (this.$validator.errors.items.length > 0) {
                    scrollToInput(this.$validator.errors.items[0].field);
                }

                return;
            }

            this.place(paymentMethod);
        } else {
            // Hide hubspot popup
            hideHubSpotPopup();

            if (
                checkout.selectedPaymentMethod &&
                checkout.selectedPaymentMethod.code === 'hipay_oney' &&
                !this.checkOneyTelephone(checkout.shippingAddress.telephone)
            ) {
                this.openModal('oney-phone-modal');
                return;
            }

            // Additional payment validation
            const hiddenErrors = await this.additionalPaymentValidation(paymentMethod);

            if (!hiddenErrors) {
                this.loading = true;

                await this.advanceToReview();
            }
        }
    }

    private async additionalPaymentValidation(paymentMethod: string) {
        let hiddenErrors = false;

        // VALIDATE HIPAY
        if (
            checkout.selectedPayment === 'hipay' &&
            store.state.options.payment.hipay.use_hostedfields &&
            payment.additionalData.hipay_tokenization.tokenId === 0
        ) {
            const methodData = payment.dataByMethod(paymentMethod);
            try {
                const hfToken = await methodData.tokenize(payment.additionalData.hipay_tokenization);
                payment.additionalData.hipay_tokenization.hostedfields_tokenization = hfToken;
            } catch (e) {
                hiddenErrors = true;
                err(e);
            }
        }

        // VALIDATE SCALAPAY, PAYPAL
        try {
            await this.validate();
            if (
                checkout.selectedPaymentMethod &&
                ['scalapay', 'payin4', 'wf_paypal', 'wf_paypalpaylater'].includes(
                    checkout.selectedPaymentMethod.code,
                )
            ) {
                await payment.registerMethod({ methodCode: checkout.selectedPaymentMethod.code }).then((result) => {
                    if (
                        (checkout.selectedPaymentMethod.code === 'wf_paypal' && !result.paid) ||
                        (['scalapay', 'payin4'].includes(checkout.selectedPaymentMethod.code) && !result)
                    ) {
                        throw new Error(result);
                    }
                });
            }
        } catch (e) {
            if (typeof e === 'function') {
                e();
            }

            hiddenErrors = true;
        }

        // VALIDATE STRIPE
        if (checkout.selectedPaymentMethod.code === 'stripe_payments') {
            const { validationResult, validationMessage } = await stripe.validateStripePaymentElement();

            if (!validationResult) {
                hiddenErrors = true;
                handleMessage('error', validationMessage);
            }
        }

        return hiddenErrors;
    }

    private advanceToReview() {
        if (checkout.requestInvoice.requested || this.changeAddressFlag || !this.isSameSelected()) {
            if (this.changeAddressFlag) {
                checkout.billingAddress.customer_address_id = 0;
                checkout.setSelectedAddressId({ type: 'billing', id: 0 });
            } else if (this.isSameSelected()) {
                checkout.billingAddress.customer_address_id = checkout.shippingAddress.customer_address_id;
            }

            // retrieve all actual customer address ids
            let oldAddressIds = user.customer.addresses.map((a) =>
                !checkout.billingAddress.customer_address_id ||
                (checkout.billingAddress.customer_address_id &&
                    checkout.billingAddress.customer_address_id !== a.id)
                    ? a.id
                    : 0,
            );

            oldAddressIds = oldAddressIds.filter((v) => v !== 0);
            const normalized = quoteAddressToCustomerAddress(checkout.billingAddress) as AddressModel;
            delete normalized.id;

            // set again customer address id if set
            if (checkout.billingAddress.customer_address_id) {
                normalized.id = checkout.billingAddress.customer_address_id;
            }

            // Commented due to #29683
            // normalized.default_shipping = false;
            normalized.default_billing = true;
            user.resetAddressErrors();
            const userObj = cloneDeep(user.customer) as unknown as UserRegistrationRequest;

            for (const a of userObj.addresses) {
                a.default_billing = false;
            }

            // remove old values of selected address (if selected)
            if (checkout.billingAddress.customer_address_id) {
                userObj.addresses = userObj.addresses
                    .filter((a) => a.id !== checkout.billingAddress.customer_address_id)
                    .filter((a, index, self) => index === self.findIndex((t) => t.id === a.id));
            }

            // and add new values
            userObj.addresses.push(normalized);

            if (this.isLogged) {
                // Save addresses to customer
                userSaveData(userObj)
                    .then((res) => {
                        for (const a of res.addresses) {
                            if (!oldAddressIds.includes(a.id)) {
                                // Add new saved address
                                user.customer.addresses.push(addExtensionAttributes(a));
                                checkout.billingAddress.customer_address_id = a.id;
                                checkout.setSelectedAddressId({ type: 'billing', id: a.id });
                                // Disable change address flag
                                this.changeAddressFlag = false;
                                break;
                            }
                        }

                        if (!checkout.requestInvoice.requested) {
                            delete checkout.billingAddress.vat_id;
                            delete checkout.billingAddress.extension_attributes.pec;
                            delete checkout.billingAddress.extension_attributes.sdi_code;
                            checkout.billingAddress.custom_attributes = {};
                        }

                        this.loading = false;
                        this.goToReview();
                    })
                    .catch((e) => {
                        this.loading = false;
                        handleError(e);
                    });
            } else {
                if (!checkout.requestInvoice.requested) {
                    delete checkout.billingAddress.vat_id;
                    delete checkout.billingAddress.extension_attributes.pec;
                    delete checkout.billingAddress.extension_attributes.sdi_code;
                    checkout.billingAddress.custom_attributes = {};
                }

                this.loading = false;
                this.goToReview();
            }
        } else {
            this.goToReview();
        }
    }

    private checkAddress() {
        if (!this.changeAddressFlag) {
            let addressId = 0;

            if (this.sameAsShipping && checkout.selectedAddressId.shipping) {
                addressId = checkout.selectedAddressId.shipping;
            } else if (!this.sameAsShipping && checkout.selectedAddressId.billing) {
                addressId = checkout.selectedAddressId.billing;
            }

            if (addressId) {
                const errors = addressValidator(checkout.billingAddress);

                if (errors.length > 0) {
                    if (this.isLogged) {
                        const link = getFullUrl(`/customer/address/edit/id/${checkout.selectedAddressId.shipping}/`);

                        err(
                            `${this.$t('Selected address has invalid fields').toString()}:<br>${errors.join(
                                ', ',
                            )}<br>${this.$t('<a href="{link}">Edit it</a> or insert/select another one', {
                                link,
                            }).toString()}`,
                        );
                    } else {
                        handleMessage('error', `${this.$t('Selected address has invalid fields').toString()}`);
                    }

                    user.setAddressError(checkout.selectedAddressId.billing);
                    return false;
                }
            }
        }

        return true;
    }

    private goToReview() {
        this.loading = false;
        checkout.setConfirmStep(true);
        checkout.setCheckReview(false);
        checkout.flagStep({ flag: true, type: 'u', stepName: 'confirm' });
        checkout.flagStep({ flag: true, type: 'a', stepName: 'confirm' });
        checkout.flagStep({ flag: false, type: 'a', stepName: 'invoice' });
        window.scrollTo(0, 0);
        this.reloadKlarnaWidgets();
    }

    private async place(paymentMethod: string) {
        // validate
        try {
            await this.validate();
        } catch (e) {
            if (typeof e === 'function') {
                e();
            }
            return;
        }

        this.loading = true;
        checkout.flagPlacingOrder(true);

        let paymentBillingAddress = normalizeQuoteAddress(checkout.billingAddress);

        if (checkout.billingSameAsShipping) {
            const shippingAddressClone = normalizeQuoteAddress(checkout.shippingAddress);
            delete shippingAddressClone.id;

            if (checkout.requestInvoice.requested) {
                shippingAddressClone.vat_id = paymentBillingAddress.vat_id;
                shippingAddressClone.company = paymentBillingAddress.company;
                shippingAddressClone.extension_attributes.pec = paymentBillingAddress.extension_attributes.pec;
                shippingAddressClone.extension_attributes.sdi_code =
                    paymentBillingAddress.extension_attributes.sdi_code;
            } else {
                shippingAddressClone.vat_id = '';
                shippingAddressClone.company = '';
                shippingAddressClone.extension_attributes.pec = '';
                shippingAddressClone.extension_attributes.sdi_code = '';
            }

            checkout.setBillingAddress(shippingAddressClone);
            paymentBillingAddress = shippingAddressClone;
            paymentBillingAddress.customer_address_id = 0;
        }

        if (paymentBillingAddress.id) {
            delete paymentBillingAddress.id;
        }

        this.methodsInitPromises.push(validateBeforePlace(paymentBillingAddress, checkout.email));

        Promise.all(this.methodsInitPromises)
            .then(() => {
                // all methods has been prepared
                let redirectUrl = '/checkout/onepage/success';
                const methodData = payment.dataByMethod(paymentMethod);
                if (methodData && methodData.redirectUrl) {
                    redirectUrl = methodData.redirectUrl;
                }

                // eslint-disable-next-line no-prototype-builtins
                if (this.paymentData.hasOwnProperty(paymentMethod)) {
                    methodData.paymentData = this.paymentData[paymentMethod];
                }

                getTotals()
                    .then(async (totals) => {
                        // get totals before pay to prevent wrong capture
                        const payPayload = {
                            amount: this.getGrandTotal(totals.total_segments),
                            methodCode: paymentMethod,
                            params: methodData,
                        };

                        if (['scalapay', 'payin4'].includes(paymentMethod)) {
                            await redirectToScalapay(paymentMethod)
                                .then((result) => {
                                    if (result.result && result.redirect) {
                                        gtmhelpers.trackMethod(paymentMethod === 'scalapay' ? '3' : '4', paymentMethod);

                                        window.location.href = result.redirect;
                                    }
                                })
                                .catch((error) => {
                                    this.loading = false;
                                    checkout.flagPlacingOrder(false);
                                    saveLog(`Error while pay scalapay: ${error.error}`);
                                    handleMessage('error', error.error);
                                });

                            return;
                        }

                        payment.pay(payPayload).then((payResult) => {
                            if (payResult.success) {
                                gtmhelpers.trackMethod('3', paymentMethod);
                                bus.$emit(paidEvent, {
                                    payData: payResult.data,
                                    paymentMethod,
                                    redirectUrl,
                                });
                            } else {
                                this.loading = false;
                                checkout.flagPlacingOrder(false);
                                saveLog(`Error while pay: ${payResult.error}`);
                                handleMessage('error', payResult.error);
                            }
                        });
                    })
                    .catch(() => {
                        this.loading = false;
                        checkout.flagPlacingOrder(false);
                    });
            })
            .catch((e) => {
                this.loading = false;
                checkout.flagPlacingOrder(false);
                handleError(e, true);
            });
    }

    private validatePrivacy() {
        this.$validator.validate('privacy_agreement');
    }

    private validateSales() {
        this.$validator.validate('sales_agreement');
    }

    private validateEducationSalesConditions() {
        this.$validator.validate('education_sales_conditions');
    }

    private getGrandTotal(totalSegments: TotalSegment[]) {
        const grandTotal = totalSegments.find((total) => {
            return total.code === 'grand_total';
        });
        return grandTotal ? grandTotal.value : 0;
    }

    private isSameSelected(): boolean {
        return checkout.selectedAddressId.billing === checkout.selectedAddressId.shipping;
    }

    private openModal(id: string) {
        ui.openModal(id);
    }

    private closeModal(id: string) {
        ui.closeModal(id);
    }

    private updateReviewPhone(id: string) {
        if (this.checkOneyTelephone(checkout.shippingAddress.telephone)) {
            this.methodsInitPromisesString.push(updateShippingTelephone(this.shippingAddress));
            const $this = this;

            Promise.all(this.methodsInitPromisesString)
                .then(() => {
                    $this.closeModal(id);
                })
                .catch((e) => {
                    handleError(e, true);
                });
        } else {
            handleMessage('error', this.$t('Telephone must be a valid italian mobile phone').toString());
        }
    }

    private created() {
        device.detectMobile();
    }

    private getPaymentMessages(): string {
        if (this.selectedPaymentMethod && checkout.messages[this.selectedPaymentMethod.code]) {
            return checkout.messages[this.selectedPaymentMethod.code];
        }
        return '';
    }

    private async scalapayCreateOrder(grandTotal: number, paymentMethod: string) {
        let payload: any = {};
        try {
            if (checkout.agreementsAccepted) {
                let { billingAddress } = checkout;

                if (checkout.billingSameAsShipping) {
                    const shippingAddressClone = normalizeQuoteAddress(checkout.shippingAddress);
                    delete shippingAddressClone.id;

                    if (checkout.requestInvoice.requested) {
                        shippingAddressClone.vat_id = billingAddress.vat_id;
                        shippingAddressClone.company = billingAddress.company;
                        shippingAddressClone.extension_attributes.pec = billingAddress.extension_attributes.pec;
                        shippingAddressClone.extension_attributes.sdi_code =
                            billingAddress.extension_attributes.sdi_code;
                    } else {
                        shippingAddressClone.vat_id = '';
                        shippingAddressClone.company = '';
                        shippingAddressClone.extension_attributes.pec = '';
                        shippingAddressClone.extension_attributes.sdi_code = '';
                    }

                    checkout.setBillingAddress(shippingAddressClone);
                    billingAddress = shippingAddressClone;
                }

                const request: PaymentInformationRequest = {
                    cartId: cart.cartToken.toString() !== '' ? cart.cartToken : cart.cart.id,
                    billingAddress: normalizeQuoteAddress(billingAddress),
                    email: checkout.email,
                    paymentMethod: {
                        method: paymentMethod,
                        po_number: undefined,
                        additional_data: checkout.additionalData,
                    },
                };

                delete request.billingAddress.default_shipping;
                delete request.billingAddress.default_billing;

                // eslint-disable-next-line no-prototype-builtins
                if (request.billingAddress.hasOwnProperty('id')) {
                    delete request.billingAddress.id;
                }

                localStorage.setItem('payment-request', JSON.stringify(request));

                const shippingAddr = normalizeQuoteAddress(checkout.shippingAddress);
                const [error, orderData] = await to(createMagentoOrder(request));

                if (error) {
                    localStorage.removeItem('payment-request');
                    handleError(error);

                    return false;
                }

                checkout.flagOrderPlaced(true);
                localStorage.removeItem('payment-request');

                if (orderData.increment_id) {
                    payload = {
                        intent: 'CAPTURE',
                        application_context: {
                            brand_name: 'scalapay',
                            shipping_preference: 'SET_PROVIDED_ADDRESS',
                        },
                        payer: {
                            email_address: checkout.email,
                        },
                        purchase_units: [
                            {
                                amount: {
                                    value: grandTotal,
                                },
                                shipping: {
                                    name: {
                                        full_name: `${shippingAddr.firstname} ${shippingAddr.lastname}`,
                                    },
                                    address: {
                                        address_line_1: shippingAddr.street[0],
                                        address_line_2: shippingAddr.street[1],
                                        admin_area_2: shippingAddr.city,
                                        admin_area_1: shippingAddr.region,
                                        postal_code: shippingAddr.postcode,
                                        country_code: shippingAddr.country_id,
                                    },
                                },
                                invoice_id: orderData.increment_id,
                            },
                        ],
                    };
                } else {
                    handleMessage('error', i18n.t('Error occurred while placing order').toString());
                }

                return true;
            }
        } catch (error) {
            handleError([`Create order error - ${error}`, payload]);
        }

        return true;
    }

    private reloadKlarnaWidgets() {
        this.reloadKlarnaWidget('pay_now');
        this.reloadKlarnaWidget('pay_later');
        this.reloadKlarnaWidget('pay_over_time');
    }

    private reloadKlarnaWidget(method: string) {
        this.$nextTick(() => {
            setTimeout(() => {
                const elId = `klarna-payments-container-${method}`;
                const klarnaEl = document.getElementById(elId);
                if (klarnaEl) {
                    Klarna.Payments.load({
                        container: `#${elId}`,
                        payment_method_category: method,
                    });
                }
            }, 1500);
        });
    }

    private isValidEmail(email: string) {
        return /^[^@]+@\w+(\.\w+)+\w$/.test(email);
    }

    private getPrice(item: CartItem) {
        let val = 0;

        // If custom price is set, return that regardless
        if ((item.extension_attributes.extcustom_price || 0) > 0) {
            return item.extension_attributes.extcustom_price;
        }

        // If giftcard take the standard price (can't have tier prices)
        if (item.product_type === 'giftcard') {
            return item.price;
        }

        item.extension_attributes.exttier_prices.some((price) => {
            if (!val && item.qty >= price.qty) {
                val = price.value;
                return true;
            }

            return false;
        });

        return item.extension_attributes.extcustom_price || val || item.extension_attributes.extfinal_price;
    }
}
